<div class="bg-neutral-10">
  <div
    class="bg-mint-160 h-8 flex text-white justify-between items-center"
    [class]="onboardingStore.inProgress() ? 'px-0 pr-1' : 'px-1'"
  >
    @if (onboardingStore.inProgress() && supportedOnboardingPage) {
      <div
        class="bg-neutral-80 h-8 flex items-center justify-between pl-4 pr-1 w-[160px]"
      >
        <div class="flex items-center">
          <span
            class="svg-icons icon-onboarding icon-16 h-4 w-4 flex-shrink-0"
          ></span>
          <span class="subtitle-1 leading-none px-2">
            {{ 'outlook.onboarding.title' | translate }}
          </span>
        </div>
        <button
          kendoButton
          fillMode="flat"
          iconClass="fa-icons icon-xmark icon-12"
          [attr.aria-label]="'outlook.onboarding.exitOnboarding' | translate"
          (click)="onboardingService.quit()"
        ></button>
      </div>
    } @else {
      <div class="flex items-center min-w-0 flex-1">
        @if (!onboardingStore.inProgress()) {
          @if (canNavigateBack()) {
            <button
              kendoButton
              fillMode="flat"
              iconClass="fa-icons icon-regular icon-16 icon-chevron-left"
              [attr.aria-label]="'outlook.buttons.back' | translate"
              (click)="back()"
            ></button>
          }
          <p
            [ngClass]="canNavigateBack() ? 'pl-1' : 'pl-4'"
            class="subtitle-1 pr-2 min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap"
          >
            {{ pageTitle() }}
          </p>
        }
      </div>
    }
    <div class="flex gap-1">
      @if (showPrivacySecurityButton()) {
        <button
          kendoTooltip
          [callout]="false"
          [tooltipTemplate]="tooltipTemplate"
          [title]="'outlook.iqBoost.privacySecurity.title' | translate"
          kendoButton
          fillMode="flat"
          [attr.aria-label]="
            'outlook.iqBoost.privacySecurity.title' | translate
          "
          (click)="showPrivacySecurity.set(true)"
        >
          <span class="flex items-center gap-1">
            @if (showAnonymizer()) {
              <span
                class="maximizer-icons icon-anonymizer icon-16 text-bush-green-100"
              ></span>
            } @else {
              <span class="fa-icons icon-unlock icon-14 text-neutral-60"></span>
            }
            @if (showDataSource()) {
              <span
                class="maximizer-icons icon-maximizer-data-server icon-16 text-bush-green-100"
              ></span>
            } @else {
              <span class="fa-icons icon-globe icon-14 text-neutral-60"></span>
            }
            @if (showServerRegion()) {
              <span
                class="maximizer-icons icon-canada-server icon-16 text-bush-green-100"
              ></span>
            } @else {
              <span
                class="fa-icons icon-earth-americas icon-14 text-neutral-60"
              ></span>
            }
          </span>
        </button>
      }
      @if (
        !onboardingStore.inProgress() &&
        supportedOnboardingPage &&
        outlookStore.doesGraphAccountMatchInbox() &&
        outlookStore.hasActiveAccount()
      ) {
        <button
          kendoTooltip
          [callout]="false"
          [tooltipTemplate]="tooltipTemplate"
          [title]="'outlook.onboarding.startOnboarding' | translate"
          id="outlook-menu-ui-menu-openOnboarding"
          [class]="showPrivacySecurityButton() ? 'ml-6' : 'ml-2'"
          kendoButton
          fillMode="flat"
          iconClass="svg-icons icon-onboarding icon-16"
          (click)="openOnboarding()"
          [attr.aria-label]="'outlook.onboarding.startOnboarding' | translate"
        ></button>
      }
      <kendo-dropdownbutton
        #menuDropdown
        id="outlook-menu-ui-menu-open"
        fillMode="flat"
        [attr.aria-label]="'outlook.menu.label' | translate"
        iconClass="fa-icons icon icon-16 icon-bars"
        [data]="menu"
        [disabled]="onboardingStore.inProgress() && supportedOnboardingPage"
      >
        <ng-template kendoDropDownButtonItemTemplate let-dataItem>
          @if (dataItem.tag === 'userProfile') {
            <div
              id="outlook-menu-ui-menu-{{ dataItem.id }}"
              class="user w-full flex items-center p-2 gap-2 max-w-[250px]"
            >
              <div
                class="avatar avatar-inserv-10 avatar-sm text-black shrink-0"
              >
                {{ dataItem.text | nameInitials }}
              </div>
              <div class="flex flex-col min-w-0 flex-1">
                <p class="subtitle-2 text-neutral-90 truncate leading-tight">
                  {{ dataItem.text }}
                </p>
                <p class="caption text-neutral-70 truncate">
                  {{ dataItem.title }}
                </p>
              </div>
            </div>
          } @else {
            <div
              id="outlook-menu-ui-menu-{{ dataItem.id }}"
              class="menu w-full flex items-center max-w-[250px]"
              [class]="dataItem.class"
            >
              @if (dataItem.icon) {
                <span [class]="dataItem.icon" class="mr-2"></span>
              }
              <p
                kendoTooltip
                [tooltipTemplate]="tooltipTemplate"
                position="bottom"
                [callout]="false"
                [title]="dataItem.text"
                [attr.data-title]="dataItem.text"
                class="overflow-hidden text-ellipsis whitespace-nowrap text-center"
                [removeIfNotOverflow]="true"
              >
                {{ dataItem.text }}
                @if (dataItem.tag === 'syncError') {
                  <span
                    class="caption block whitespace-normal break-words text-pretty"
                    >{{ 'outlook.menu.syncStatusErrorAuth' | translate }}
                  </span>
                }
              </p>
            </div>
          }
        </ng-template>
      </kendo-dropdownbutton>
    </div>
  </div>

  @if (!this.outlookStore.hasActiveAccount() && !disableMsalAuth) {
    @defer (on timer (500ms)) {
      <maximizer-outlook-msal-account-warning></maximizer-outlook-msal-account-warning>
    }
  } @else if (
    !outlookStore.doesGraphAccountMatchInbox() &&
    this.outlookStore.hasActiveAccount() &&
    hideMsalMismatchDialog &&
    !disableMsalAuth
  ) {
    @defer (on timer(500ms)) {
      <maximizer-outlook-msal-mismatch-error></maximizer-outlook-msal-mismatch-error>
    }
  }
</div>

@if (onboardingStore.inProgress() && supportedOnboardingPage) {
  <div animate.enter="slide-down-enter" animate.leave="slide-down-leave">
    <maximizer-outlook-onboarding-stepper></maximizer-outlook-onboarding-stepper>
  </div>
}

@if (showOnboardingDialog()) {
  <maximizer-outlook-onboarding-celebration
    [step]="onboardingService.isLastStep() ? 'finish' : 'start'"
  ></maximizer-outlook-onboarding-celebration>
}

@if (showRemindLater) {
  <maximizer-outlook-onboarding-remind-later
    (showRemindLater)="showRemindLater = $event"
  ></maximizer-outlook-onboarding-remind-later>
}

@if (
  !this.outlookStore.hasActiveAccount() &&
  !hideMsalLoginDialog &&
  !disableMsalAuth
) {
  <maximizer-outlook-msal-login-message
    (hideMsalLoginDialog)="hideMsalLoginDialog = $event"
  ></maximizer-outlook-msal-login-message>
}

@if (
  !outlookStore.doesGraphAccountMatchInbox() &&
  this.outlookStore.hasActiveAccount() &&
  !hideMsalMismatchDialog &&
  !disableMsalAuth
) {
  @defer (on timer(1000ms)) {
    <maximizer-outlook-msal-mismatch-message
      (hideMsalMismatchDialog)="hideMsalMismatchDialog = $event"
    ></maximizer-outlook-msal-mismatch-message>
  }
}

@if (showSyncStatusMessage()) {
  <maximizer-outlook-status-message
    type="error"
    [message]="'outlook.sync.status.authError' | translate"
    [disableDefaultLinkNavigation]="true"
    (messageLinkClick)="onSyncStatusMessageLinkClick($event)"
    [dismissText]="'outlook.buttons.dismiss' | translate"
    (dismiss)="dismissSyncStatus()"
    [actionText]="'outlook.buttons.reAuthenticate' | translate"
    (action)="reinstallOutlookSync(true)"
  ></maximizer-outlook-status-message>
}

@if (openSyncSettings) {
  <maximizer-outlook-sync-settings
    (openSyncSettings)="openSyncSettings = $event"
    (syncSettingsUpdated)="getOutlookSyncSettings(true)"
  ></maximizer-outlook-sync-settings>
}

@if (openInstallSync) {
  <kendo-dialog [width]="270">
    <maximizer-outlook-sync-install
      [componentType]="'dialog'"
      (openInstallSync)="openInstallSync = $event"
    ></maximizer-outlook-sync-install>
  </kendo-dialog>
}

@if (onboardingService.showExitDialog()) {
  <maximizer-outlook-onboarding-exit> </maximizer-outlook-onboarding-exit>
}

@if (onboardingService.showRemindLater()) {
  <kendo-dialog [width]="256">
    <div class="py-2">
      <p class="text-body">
        {{ 'outlook.onboarding.later.message' | translate }}
      </p>
      <div class="flex justify-end">
        <button
          kendoButton
          themeColor="primary"
          class="uppercase"
          (click)="onboardingService.showRemindLater.set(false)"
        >
          {{ 'outlook.buttons.ok' | translate }}
        </button>
      </div>
    </div>
  </kendo-dialog>
}

@if (showPrivacySecurity()) {
  <maximizer-outlook-iq-boost-privacy-security
    [anonymizerStatus]="anonymizerStatus()"
    [dataSource]="dataSource()"
    [serverRegion]="serverRegion()"
    [anonymizerEnabled]="showAnonymizer()"
    [dataSourceEnabled]="showDataSource()"
    [serverRegionEnabled]="showServerRegion()"
    (closeDialog)="showPrivacySecurity.set(false)"
  ></maximizer-outlook-iq-boost-privacy-security>
}

@if (loading()) {
  <maximizer-loader type="legacy"></maximizer-loader>
}

<maximizer-outlook-notification #notification [closable]="true">
</maximizer-outlook-notification>

@if (dismissSyncStatusMessage()) {
  <kendo-dialog [width]="250">
    <div class="narrow p-2 flex flex-col gap-2">
      <p class="subtitle-2">
        {{ 'outlook.sync.status.dismiss.title' | translate }}
      </p>
      <p class="text-body">
        {{ 'outlook.sync.status.dismiss.message' | translate }}
      </p>
      <div class="flex justify-end pt-2">
        <button
          kendoButton
          themeColor="primary"
          class="uppercase"
          (click)="dismissSyncStatusMessage.set(false)"
        >
          {{ 'outlook.buttons.ok' | translate | uppercase }}
        </button>
      </div>
    </div>
  </kendo-dialog>
}

<ng-template #tooltipTemplate let-anchor>
  <p class="caption text-center text-neutral-90 whitespace-nowrap">
    {{ anchor.nativeElement.getAttribute('data-title') }}
  </p>
</ng-template>
